export default __webpack_public_path__ + "static/media/8.03214c63.png";